export default __webpack_public_path__ + "static/media/correct.9039b302.png";